import { beneObject } from './useGetRecepinetList';
import {
  CASH_TRANSFER_UP_METHOD_ICON,
  SEND_MONEY_BANK_ICON,
  SEND_MONEY_CASH_PICKUP_ICON,
  SEND_MONEY_PROXY_ICON,
  WALLET_ICON
} from '@Images';
import { Partner_Location } from '../utils/constants';

export const filteredRecipientListForBeneDropdown = (data: any[]) => {
  return data?.reduce((acc: any, pre: beneObject) => {
    if (pre.routing_config_type === 'BANK') {
      return [
        ...acc,
        {
          ...pre,
          renderName: pre.bank_name,
          renderAccountNumber: pre.bank_account_number,
          renderIcon: SEND_MONEY_BANK_ICON,
          iconName: 'send-money-bank',
          maskedAccountNumber: pre.masked_account_number,
          subtitle: 'Bank deposit'
        }
      ];
    } else if (pre.routing_config_type === 'VISA_DEBIT_CARD') {
      return [
        ...acc,
        {
          ...pre,
          renderName: pre.card_issuer_name || '',
          renderAccountNumber: pre.card_number || '',
          renderIcon: CASH_TRANSFER_UP_METHOD_ICON,
          iconName: 'cash-transfer-up-method',
          maskedAccountNumber: pre.masked_account_number,
          subtitle: 'Debit card'
        }
      ];
    } else if (pre.routing_config_type === 'GEO_SWIFT_CARD') {
      return [
        ...acc,
        {
          ...pre,
          renderName: pre.card_issuer_name || '',
          renderAccountNumber: pre.card_number || '',
          renderIcon: CASH_TRANSFER_UP_METHOD_ICON,
          iconName: 'cash-transfer-up-method'
        }
      ];
    } else if (
      pre.routing_config_type === 'CASH_PAYOUT' ||
      pre.routing_config_type === 'MONEYGRAM_CASH_PAYOUT'
    ) {
      return [
        ...acc,
        {
          ...pre,
          renderName: pre.card_issuer_name || Partner_Location,
          renderAccountNumber: pre.card_number || 'Cash pickup',
          renderIcon: SEND_MONEY_CASH_PICKUP_ICON,
          iconName: 'send-money-cash-pickup'
        }
      ];
    } else if (pre.routing_config_type === 'WALLET') {
      let sub_title = pre.upper || '';
      if (sub_title.length > 20) {
        sub_title = sub_title.substring(0, 19) + '...';
      }
      if (pre?.payout_method_config?.label?.toUpperCase() === 'ALIPAY WALLET') {
        return [
          ...acc,
          {
            ...pre,
            maskedAccountNumber: pre.masked_account_number || '',
            renderIcon: SEND_MONEY_CASH_PICKUP_ICON,
            iconName: 'send-money-cash-pickup',
            subtitle: pre.payout_method_config.label
          }
        ];
      }
      if (pre?.payout_method_config?.label?.toUpperCase() === 'E-WALLET') {
        return [
          ...acc,
          {
            ...pre,
            maskedAccountNumber: pre.masked_account_number || '',
            renderIcon: WALLET_ICON,
            iconName: 'wallet',
            subtitle: pre?.payout_method_config?.label,
            renderName: pre?.upper
          }
        ];
      } else {
        return [
          ...acc,
          {
            ...pre,
            renderMobileNo: `+${pre.mobile_country_code} ${pre.mobile_number}`,
            renderIcon: SEND_MONEY_CASH_PICKUP_ICON,
            iconName: 'send-money-cash-pickup',
            subtitle: sub_title && `${sub_title} wallet`
          }
        ];
      }
    } else if (pre.routing_config_type === 'PROXY') {
      const subTitle = `${pre.proxy_label} - ${pre.proxy_type}`;
      return [
        ...acc,
        {
          ...pre,
          renderMobileNo: pre.proxy_value,
          renderIcon: SEND_MONEY_PROXY_ICON,
          iconName: 'send-money-proxy',
          subtitle: subTitle
        }
      ];
    }
    return acc;
  }, []);
};
